import { useRef } from "react";
import classes from "./pagination.module.scss";

import { formatMiles } from "@/services/Utils";
import { ReactComponent as RightArrow } from "@/assets/images/icons/Pagination/right-arrow.svg";
import { ReactComponent as LeftArrow } from "@/assets/images/icons/Pagination/left-arrow.svg";
import { ReactComponent as Clear } from "@/assets/images/icons/Pagination/clear.svg";

import { Row, Col } from "react-bootstrap";

const Pagination = ({
	page,
	setPage,
	paginate,
	setPaginate,
	setSearch,
	quantityElements,
	LastPage,
	FromElements,
	ToElements,
	setDefaultPaginate = null,
	defaultUnit,
	setDefaultUnit,
	dateFilter = false,
	date = null,
	setDate = null,
	dateTo = null,
	setDateTo = null,
}) => {
	const refDate = useRef(null);
	const refDateTo = useRef(null);

	const show_100 = 100;
	let default_paginate = 8;
	if (setDefaultPaginate) {
		default_paginate = setDefaultPaginate;
	}

	const handlePaginate = (new_paginate) => {
		setSearch("");
		setPage(1);
		if (paginate !== default_paginate) {
			setPaginate(default_paginate);
		} else {
			setPaginate(new_paginate);
		}
	};

	const handleSearch = (e) => {
		setSearch(e.target.value);
	};

	const handleNext = (value) => {
		if (value && LastPage > page) {
			setPage(page + 1);
		}

		if (!value && page !== 1) {
			setPage(page - 1);
		}
	};

	const cleanDates = () => {
		setDate("");
		setDateTo("");

		refDate.current.type = "text";
		refDateTo.current.type = "text";
	};

	return (
		<Row className={classes.divMain}>
			<Col xs={6} md={2} className={classes.divPaginate}>
				<span>
					<LeftArrow className={classes.iconPagination} onClick={() => handleNext(false)} />
					{FromElements} - {ToElements} de {formatMiles(quantityElements)}
					<RightArrow className={classes.iconPagination} onClick={() => handleNext(true)} />
				</span>
			</Col>
			<Col xs={6} md={2} className={classes.divShow}>
				<span className={classes.buttonShow} onClick={() => handlePaginate(show_100)}>
					VER {paginate === show_100 ? default_paginate : show_100}
				</span>
			</Col>

			<Col xs={12} md={defaultUnit ? (dateFilter ? 2 : 5) : dateFilter ? 4 : 8} className={classes.divSearch}>
				<input placeholder="BUSCAR" className={`${!defaultUnit ? classes.inputSearch : classes.inputSearchTotal}`} onChange={(e) => handleSearch(e)} />
			</Col>

			{dateFilter && (
				<Col xs={12} md={3} className={classes.divDates}>
					<div className={classes.divFilter}>
						<div className={classes.inputFilter}>
							<input
								type="text"
								value={date}
								onChange={(e) => setDate(e.target.value)}
								placeholder="DESDE"
								onFocus={(e) => (e.target.type = "date")}
								className={classes.inputDateFrom}
								ref={refDate}
							/>
						</div>
						<div className={classes.inputFilter}>
							<input
								type="text"
								value={dateTo}
								onChange={(e) => setDateTo(e.target.value)}
								placeholder="HASTA"
								onFocus={(e) => (e.target.type = "date")}
								className={classes.inputDateTo}
								ref={refDateTo}
							/>
						</div>
						<div className={classes.bottonFilter}>
							<button className={classes.buttonCleanFilter} onClick={() => cleanDates()}>
								<Clear className={classes.icon} />
							</button>
						</div>
					</div>
				</Col>
			)}

			{defaultUnit && (
				<Col xs={12} md={3}>
					<select className={classes.inputUnit} value={defaultUnit} onChange={(e) => setDefaultUnit(e.target.value)}>
						<option value="1">g - cc</option>
						<option value="1000">Kg - L</option>
						<option value="1000000">Tn - KL</option>
					</select>
				</Col>
			)}
		</Row>
	);
};

export default Pagination;
